import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPlan } from '@/models/checkout.model';
import { SLICE_NAMES } from '../constants';

interface CheckoutModalState {
  isOpen: boolean;
  source: string;
  loginSource: string;
  plans: IPlan[];
  successRedirectUrl: string | null;
}

const initialState: CheckoutModalState = {
  isOpen: false,
  source: '',
  loginSource: '',
  plans: [],
  successRedirectUrl: null,
};

const checkoutModalSlice = createSlice({
  name: SLICE_NAMES.CHECKOUT_MODAL,
  initialState,
  reducers: {
    setCheckoutPlans: (state, action: PayloadAction<IPlan[]>) => {
      state.plans = action.payload;
    },
    openCheckoutModal: (
      state,
      action: PayloadAction<{
        source: string;
        loginSource: string;
        successRedirectUrl?: string;
      }>
    ) => {
      state.isOpen = true;
      state.source = action.payload.source;
      state.loginSource = action.payload.loginSource;
      state.successRedirectUrl = action.payload.successRedirectUrl ?? null;
    },
    closeCheckoutModal: state => {
      state.isOpen = false;
      state.source = '';
      state.loginSource = '';
      state.successRedirectUrl = null;
    },
  },
});

export const { setCheckoutPlans, openCheckoutModal, closeCheckoutModal } =
  checkoutModalSlice.actions;
export const checkoutModalReducer = checkoutModalSlice.reducer;
